import {
  MODAL_ADD,
  MODAL_MOD,
  MODAL_DEL,
  MODAL_DEL_MAS,
  ACT_DATA_GENERICA,
  ACT_DATA_GENERICAS,
  ACT_DATA_GENERICAS_ELIMINAR,
  ACT_RENDER,
  MODAL_ADM_VALORES,
} from "../actions/actGenericas";

const initialState = {
  modalAdd: false,
  modalMod: false,
  modalDel: false,
  modalDelMas: false,
  generica: {
    id: 0,
    nombre: "",
    descripcion: "Ninguna",
  },
  genericas: [],
  render: false,
  modalAdmValores: false,
  idsEliminarMasivo: [],
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case MODAL_ADD:
      return Object.assign({}, state, {
        modalAdd: action.show
      })
    case MODAL_MOD:
      return Object.assign({}, state, {
        modalMod: action.show
      })
    case MODAL_DEL:
      return Object.assign({}, state, {
        modalDel: action.show
      })
    case MODAL_DEL_MAS:
      return Object.assign({}, state, {
        modalDelMas: action.show
      })
    case ACT_DATA_GENERICA:
      return Object.assign({}, state, {
        generica: action.generica
      })
    case ACT_DATA_GENERICAS:
      return Object.assign({}, state, {
        genericas: action.genericas
      })
    case ACT_DATA_GENERICAS_ELIMINAR:
      return Object.assign({}, state, {
        idsEliminarMasivo: action.ids
      })
    case ACT_RENDER:
      return Object.assign({}, state, {
        render: action.render
      })
    case MODAL_ADM_VALORES:
      return Object.assign({}, state, {
        modalAdmValores: action.show
      })
    default:
      return state;
  }
}

export default reducer;
